<template>
  <div v-if="isViewActiveLocal" ref="topic_content">
      <div class="limit-width_fixed-scalable mb-3" style="text-align: left;">
        <div style="text-align: left;" class="my-6">
          <img style="height:110px;" :src="siteLogoUrl" />
        </div>
        <span class="mt-3" style="display: inline-flex">
          <img id="profileimg" :src="profilePic" style="width: 23%; height: auto;">
          <div>
            <p style="font-size: 16pt;color:white;" class="ml-4 mt-3">Hi {{ user_displayName.split(' ')[0] }},</p>
            <p style="font-size: 11pt;color:white;" class="ml-4">Welcome back!</p>
          </div>
        </span>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    isViewActive: {
      required: false,
    },
    siteLogoUrl: {
      required: false
    },
    user_displayName: {
      required: false
    },
    profilePic: {
      required: false
    },
  },
  computed: {
    isViewActiveLocal: {
      get() {
        return this.isViewActive;
      }
    }
  },
};
</script>